export const LOAN_INCENTIVES_STUB = {
  bonus: [
    {
      id: 16837099,
      type: 'CASH_REBATE',
      contentType: 'CUSTOMER_CASH',
      subprogramId: 6665699,
      sourceType: 'UNKNOWN',
      sourceTypeId: 11,
      sourceTypeValue: 'Military for Retail or Lease',
      startDate: 1594105200000,
      endDate: 1617260399999,
      comments: '',
      restrictions:
        "Honda Military Appreciation Offer provides select and eligible U.S. Military personnel and their spouse and Gold Star Family members an appreciation $500 award toward any new and untitled  2019 or newer Honda automobile when financed or leased through Honda Financial Services (HFS). (excludes Zero Due at Signing Lease program). To be eligible for this offer, you must meet certain credit criteria established by HFS, and the vehicle must be eligible for new-vehicle rates. \n\nClient Eligibility:\n Active Duty U.S. Military, (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve) and their spouses.\n Active Duty U.S. Military Ready Reserve, (Inactive National Guard, Individual Ready Reserve, Selected Reserve) and their spouses.\n U.S. Military Veterans who are within 180 days of separation from active service, and their spouses.\n U.S. Military Retirees (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve).\n Spouses of U.S. Military Retirees (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve) who are within 180 days of separation from active service.\n Gold Star Family Members are immediate relatives (Widow, Parents, Next of Kin) of members of the U.S. Armed Forces who have been killed in combat or in support of certain military activities.\n\nEligible customers must meet the following conditions at the time of purchase:\n Provide Leave and Earnings Statement (LES) as proof of military status or active service at the time of purchase or lease. \n Spouses of a member of the U.S. Military must provide proof of relationship by presenting a Military ID, and provide spouse' LES. Only a copy of the LES will be retained by the dealership for verification. \n Receive credit approval through Honda Financial Services.\n Gold Star Family Members are immediate relatives (Widow, Parents, Next of Kin) of members of the U.S. Armed Forces who have been killed in combat or in support of certain military activities.\n This offer must be redeemed towards capitalized cost reduction or down payment assistance.",
      name: 'Customer Incentives - Military for Retail or Lease',
      makeIds: [200001444],
      modelYearIds: [401844735],
      styleIds: [401844737],
      categories: ['Car', 'Midsize', 'Performance', 'Sedan'],
      regions: ['i109550', 'i77393', 'i102303', 'i78186', 'i109699', 'i77391'],
      primary: false,
      combinableLevel: 6,
      extended: false,
      compatibleSubprogramIds: [6665700, 6665628, 6665641, 6665656, 6665626],
      customerRebate: true,
      financing: false,
      leasing: false,
      manufacturerToDealer: false,
      expirationDateClose: false,
      ruleId: 0,
      rebateAmount: 500,
      contentTypeAsEnum: 'CUSTOMER_CASH',
    },
    {
      id: 16837100,
      type: 'CASH_REBATE',
      contentType: 'CUSTOMER_CASH',
      subprogramId: 6665700,
      sourceType: 'UNKNOWN',
      sourceTypeId: 12,
      sourceTypeValue: 'Student/College Grad for Retail or Lease',
      startDate: 1585724400000,
      endDate: 1617260399999,
      comments: '',
      restrictions:
        ' For well-qualified customers who meet Honda Graduate Program criteria, subject to approval by Honda Financial Services (HFS\n This offer must be redeemed towards capitalized cost reduction or down payment assistance.\n Bonus offer applies toward any new 2019 or newer model year Honda when financed or leased through HFS. Only offered at participating dealerships.\n Only one College Graduate Bonus offer per vehicle.\n Cannot be combined with Zero Due at Signing Lease program.\n Offer not valid on Honda Certified Pre-Owned Vehicles or used Honda vehicles.\n Verifiable proof of employment or firm commitment from an employer required.\n Must have graduated in the past two years or will graduate in the next six months.\n Must provide copy of Diploma or college transcripts with proof of graduation eligibility.',
      name: 'Customer Incentives - Student/College Grad for Retail or Lease',
      makeIds: [200001444],
      modelYearIds: [401844735],
      styleIds: [401844737],
      categories: ['Car', 'Midsize', 'Performance', 'Sedan'],
      regions: ['i109550', 'i77393', 'i102303', 'i78186', 'i109699', 'i77391'],
      primary: false,
      combinableLevel: 6,
      extended: false,
      compatibleSubprogramIds: [6665699, 6665628, 6665641, 6665656, 6665626],
      customerRebate: true,
      financing: false,
      leasing: false,
      manufacturerToDealer: false,
      expirationDateClose: false,
      ruleId: 0,
      rebateAmount: 500,
      contentTypeAsEnum: 'CUSTOMER_CASH',
    },
  ],
  financing: [
    {
      id: 16836796,
      type: 'LOW_APR',
      contentType: 'CUSTOMER_APR',
      subprogramId: 6665641,
      sourceType: 'UNKNOWN',
      sourceTypeId: 3,
      sourceTypeValue: 'Special APR',
      startDate: 1609833600000,
      endDate: 1614671999999,
      comments:
        '1.9% APR financing for 36 months at $28.6 per month, per $1,000 financed. 1.9% APR financing for 48 months at $21.65 per month, per $1,000 financed. 1.9% APR financing for 60 months at $17.48 per month, per $1,000 financed. 2.9% APR financing for 72 months at $15.15 per month, per $1,000 financed.',
      restrictions:
        'Program eligibility based on credit approval. Not all customers will qualify. Offer requires financing with *Honda Financial Services.',
      name: 'Customer APR - Special APR',
      makeIds: [200001444],
      modelYearIds: [401844735],
      styleIds: [401844737],
      categories: ['Car', 'Midsize', 'Performance', 'Sedan'],
      regions: ['i109550', 'i77393', 'i78186', 'i102303', 'i109699', 'i77391'],
      primary: false,
      combinableLevel: 0,
      extended: false,
      compatibleSubprogramIds: [6665700, 6665699],
      customerRebate: false,
      financing: true,
      leasing: false,
      manufacturerToDealer: false,
      expirationDateClose: false,
      ruleId: 0,
      termMonths: 36,
      apr: 1.9,
      creditRatingTier: 'Tier 1',
      tierMin: 760,
      tierMax: 899,
      contentTypeAsEnum: 'CUSTOMER_APR',
    },
    {
      id: 16836799,
      type: 'LOW_APR',
      contentType: 'CUSTOMER_APR',
      subprogramId: 6665641,
      sourceType: 'UNKNOWN',
      sourceTypeId: 3,
      sourceTypeValue: 'Special APR',
      startDate: 1609833600000,
      endDate: 1614671999999,
      comments:
        '1.9% APR financing for 36 months at $28.6 per month, per $1,000 financed. 1.9% APR financing for 48 months at $21.65 per month, per $1,000 financed. 1.9% APR financing for 60 months at $17.48 per month, per $1,000 financed. 2.9% APR financing for 72 months at $15.15 per month, per $1,000 financed.',
      restrictions:
        'Program eligibility based on credit approval. Not all customers will qualify. Offer requires financing with *Honda Financial Services.',
      name: 'Customer APR - Special APR',
      makeIds: [200001444],
      modelYearIds: [401844735],
      styleIds: [401844737],
      categories: ['Car', 'Midsize', 'Performance', 'Sedan'],
      regions: ['i109550', 'i77393', 'i78186', 'i102303', 'i109699', 'i77391'],
      primary: false,
      combinableLevel: 0,
      extended: false,
      compatibleSubprogramIds: [6665700, 6665699],
      customerRebate: false,
      financing: true,
      leasing: false,
      manufacturerToDealer: false,
      expirationDateClose: false,
      ruleId: 0,
      termMonths: 48,
      apr: 1.9,
      creditRatingTier: 'Tier 1',
      tierMin: 760,
      tierMax: 899,
      contentTypeAsEnum: 'CUSTOMER_APR',
    },
    {
      id: 16836802,
      type: 'LOW_APR',
      contentType: 'CUSTOMER_APR',
      subprogramId: 6665641,
      sourceType: 'UNKNOWN',
      sourceTypeId: 3,
      sourceTypeValue: 'Special APR',
      startDate: 1609833600000,
      endDate: 1614671999999,
      comments:
        '1.9% APR financing for 36 months at $28.6 per month, per $1,000 financed. 1.9% APR financing for 48 months at $21.65 per month, per $1,000 financed. 1.9% APR financing for 60 months at $17.48 per month, per $1,000 financed. 2.9% APR financing for 72 months at $15.15 per month, per $1,000 financed.',
      restrictions:
        'Program eligibility based on credit approval. Not all customers will qualify. Offer requires financing with *Honda Financial Services.',
      name: 'Customer APR - Special APR',
      makeIds: [200001444],
      modelYearIds: [401844735],
      styleIds: [401844737],
      categories: ['Car', 'Midsize', 'Performance', 'Sedan'],
      regions: ['i109550', 'i77393', 'i78186', 'i102303', 'i109699', 'i77391'],
      primary: false,
      combinableLevel: 0,
      extended: false,
      compatibleSubprogramIds: [6665700, 6665699],
      customerRebate: false,
      financing: true,
      leasing: false,
      manufacturerToDealer: false,
      expirationDateClose: false,
      ruleId: 0,
      termMonths: 60,
      apr: 1.9,
      creditRatingTier: 'Tier 1',
      tierMin: 760,
      tierMax: 899,
      contentTypeAsEnum: 'CUSTOMER_APR',
    },
    {
      id: 16836805,
      type: 'LOW_APR',
      contentType: 'CUSTOMER_APR',
      subprogramId: 6665641,
      sourceType: 'UNKNOWN',
      sourceTypeId: 3,
      sourceTypeValue: 'Special APR',
      startDate: 1609833600000,
      endDate: 1614671999999,
      comments:
        '1.9% APR financing for 36 months at $28.6 per month, per $1,000 financed. 1.9% APR financing for 48 months at $21.65 per month, per $1,000 financed. 1.9% APR financing for 60 months at $17.48 per month, per $1,000 financed. 2.9% APR financing for 72 months at $15.15 per month, per $1,000 financed.',
      restrictions:
        'Program eligibility based on credit approval. Not all customers will qualify. Offer requires financing with *Honda Financial Services.',
      name: 'Customer APR - Special APR',
      makeIds: [200001444],
      modelYearIds: [401844735],
      styleIds: [401844737],
      categories: ['Car', 'Midsize', 'Performance', 'Sedan'],
      regions: ['i109550', 'i77393', 'i78186', 'i102303', 'i109699', 'i77391'],
      primary: false,
      combinableLevel: 0,
      extended: false,
      compatibleSubprogramIds: [6665700, 6665699],
      customerRebate: false,
      financing: true,
      leasing: false,
      manufacturerToDealer: false,
      expirationDateClose: false,
      ruleId: 0,
      termMonths: 72,
      apr: 2.9,
      creditRatingTier: 'Tier 1',
      tierMin: 760,
      tierMax: 899,
      contentTypeAsEnum: 'CUSTOMER_APR',
    },
  ],
  lease: [],
  other: [],
  numIncentives: 6,
};

export const LEASE_INCENTIVES_STUB = {
  incentives: [
    {
      incentiveId: 113073,
      programId: 'H2ADL',
      programName: '2021 Honda Accord Special Financing',
      programDescription: '',
      cash: 0.0,
      expirationDate: 1614671940000,
      incentiveTermRange: [{ startTerm: 24, endTerm: 36, customerCash: 0.0, moneyFactor: 0.00066 }],
      conditionCategory: '',
      mutuallyExclusiveIncentiveIds: [],
    },
    {
      incentiveId: 103348,
      programId: 'HP-X11',
      programName: '2021 Honda College Graduate Bonus Offer',
      programDescription:
        'Provides select eligible graduates $500 toward Cap Cost Reduction or Down Payment Assistance on any 2019 or newer Honda vehicle when financed or leased through Honda Financial Services (HFS). \r\n\r\nCLIENT ELIGIBILITY:\r\nClient that has graduated within the past two years or will graduate within the next six months with a Master, Bachelor or an Associate degree from a U.S. - accredited college or registered nursing school.\r\nMust provide a copy of a diploma or college transcripts as proof of graduation eligibility and all other documents required by AFS.\r\n\r\nMust finance through HFS for a minimum of 24 months or more of regularly scheduled payments.\r\n\r\nThis incentive program CAN NOT be used with any "$0 Due at Signing Lease".',
      cash: 0.0,
      expirationDate: 1617260340000,
      incentiveTermRange: [{ startTerm: 24, endTerm: 60, customerCash: 500.0, moneyFactor: 0 }],
      conditionCategory: 'College Grad',
      mutuallyExclusiveIncentiveIds: [],
    },
    {
      incentiveId: 103350,
      programId: 'HP-X10',
      programName: '2021 Honda Military Appreciation Offer',
      programDescription:
        'Provides $500 toward Cap Cost Reduction or Down Payment Assistance on any 2019 or newer Honda vehicle when financed or leased through Honda Financial Services (HFS). \r\n \r\nCLIENT ELIGIBILITY:\r\nActive Duty U.S. Military (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve) and their spouses.   \r\nActive Duty U.S. Military Ready Reserve, (Inactive National Guard, Individual Ready Reserve, Selected Reserve) and their spouses.  \r\nU.S. Military Veterans who are within 2 years of separation from active service, and their spouses. Veteran: A service member who was discharged or released from service under conditions other than dishonorable.\r\nU.S. Military Retirees (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve). Military Retiree: Service members who remain on active duty or serve in the Reserves or Guard for a sufficient period of time (usually a minimum of 20 years).\r\nSpouses of U.S. Military Retirees (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve) who are within 2 years of separation from active service.\r\nMembers of Gold Star Families.\r\n\r\nMust finance through HFS for a minimum of 24 months or more of regularly scheduled payments.\r\n\r\nThe incentive program CAN NOT be used with:\r\nFirst Responders and Healthcare Professional Appreciation Offer\r\nAny "$0 Due at Signing Lease"',
      cash: 0.0,
      expirationDate: 1617260340000,
      incentiveTermRange: [{ startTerm: 24, endTerm: 60, customerCash: 500.0, moneyFactor: 0 }],
      conditionCategory: 'Military',
      mutuallyExclusiveIncentiveIds: [],
    },
  ],
};

export const LEASE_TERMS_INCENTIVES = {
  113073: {
    incentiveId: 113073,
    programId: 'H2ADL',
    programName: '2021 Honda Accord Special Financing',
    cash: 0,
    expirationDate: 1614671940000,
  },
  103348: {
    incentiveId: 103348,
    programId: 'HP-X11',
    programName: '2021 Honda College Graduate Bonus Offer',
    programDescription:
      'Provides select eligible graduates $500 toward Cap Cost Reduction or Down Payment Assistance on any 2019 or newer Honda vehicle when financed or leased through Honda Financial Services (HFS). \r\n\r\nCLIENT ELIGIBILITY:\r\nClient that has graduated within the past two years or will graduate within the next six months with a Master, Bachelor or an Associate degree from a U.S. - accredited college or registered nursing school.\r\nMust provide a copy of a diploma or college transcripts as proof of graduation eligibility and all other documents required by AFS.\r\n\r\nMust finance through HFS for a minimum of 24 months or more of regularly scheduled payments.\r\n\r\nThis incentive program CAN NOT be used with any "$0 Due at Signing Lease".',
    cash: 500,
    expirationDate: 1617260340000,
    conditionCategory: 'College Grad',
  },
  103350: {
    incentiveId: 103350,
    programId: 'HP-X10',
    programName: '2021 Honda Military Appreciation Offer',
    programDescription:
      'Provides $500 toward Cap Cost Reduction or Down Payment Assistance on any 2019 or newer Honda vehicle when financed or leased through Honda Financial Services (HFS). \r\n \r\nCLIENT ELIGIBILITY:\r\nActive Duty U.S. Military (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve) and their spouses.   \r\nActive Duty U.S. Military Ready Reserve, (Inactive National Guard, Individual Ready Reserve, Selected Reserve) and their spouses.  \r\nU.S. Military Veterans who are within 2 years of separation from active service, and their spouses. Veteran: A service member who was discharged or released from service under conditions other than dishonorable.\r\nU.S. Military Retirees (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve). Military Retiree: Service members who remain on active duty or serve in the Reserves or Guard for a sufficient period of time (usually a minimum of 20 years).\r\nSpouses of U.S. Military Retirees (Army, Navy, Air Force, Marines, National Guard, Coast Guard and Active Reserve) who are within 2 years of separation from active service.\r\nMembers of Gold Star Families.\r\n\r\nMust finance through HFS for a minimum of 24 months or more of regularly scheduled payments.\r\n\r\nThe incentive program CAN NOT be used with:\r\nFirst Responders and Healthcare Professional Appreciation Offer\r\nAny "$0 Due at Signing Lease"',
    cash: 500,
    expirationDate: 1617260340000,
    conditionCategory: 'Military',
  },
};
